import React from "react";
import clsx from "clsx";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import ScrollSyncPanel from "components/ScrollSync/ScrollSyncPanel/ScrollSyncPanel";
import TableRow from "../TableRow";
import VerticalDivider from "../VerticalDivider";
import {
  ESurfaceType,
  getPercentagesRow,
  getSurfaceGrandTotals,
  IRowData,
  surfaceTypes
} from "../helper";
import useCommonStyles from "../styles";
import useStyles from "./styles";

interface IProps {
  data: racehorse360.IInventoryAnalyticsBucket[];
}

const TableFooter = (props: IProps) => {
  const { data } = props;
  const classes = useStyles();
  const commonClasses = useCommonStyles();
  const { dirt, turfAndSynthetic } = surfaceTypes;

  const extractedSubClasses = data.flatMap(item => item.subclasses);
  const grandsTotalHorsesCount = extractedSubClasses.reduce((acc, cur) => {
    return acc + cur.totalCount;
  }, 0);
  const dirtGrandTotalsRow = getSurfaceGrandTotals(
    extractedSubClasses,
    dirt.dataField
  );
  const turfGrandTotalsRow = getSurfaceGrandTotals(
    extractedSubClasses,
    turfAndSynthetic.dataField
  );
  const footerData: IRowData[] = [
    {
      backgroundClassName: classes["lightGreenCells"],
      surfaces: [
        {
          type: ESurfaceType.DIRT,
          data: dirtGrandTotalsRow
        },
        {
          type: ESurfaceType.TURF_AND_SYNTHETIC,
          data: turfGrandTotalsRow
        }
      ],
      totalCount: grandsTotalHorsesCount
    },
    {
      backgroundClassName: classes["mediumGreenCells"],
      surfaces: [
        {
          type: ESurfaceType.DIRT,
          data: getPercentagesRow(dirtGrandTotalsRow, grandsTotalHorsesCount)
        },
        {
          type: ESurfaceType.TURF_AND_SYNTHETIC,
          data: getPercentagesRow(turfGrandTotalsRow, grandsTotalHorsesCount)
        }
      ],
      totalCount: null
    }
  ];

  const renderRowsContent = () => {
    return footerData.map((item, index) => (
      <TableRow key={index} data={item} />
    ));
  };

  return (
    <div className={classes.tableFooter}>
      <div className={clsx(commonClasses.colorGroupFixedCells)}>
        <div className={commonClasses.flexColumn}>
          <div className={clsx(commonClasses.cell, classes.lightGreenCells)}>
            Grand Totals
          </div>
          <div className={clsx(commonClasses.cell, classes.mediumGreenCells)}>
            Percentages
          </div>
        </div>
        <div className={commonClasses.flexColumn}>
          <div className={clsx(commonClasses.cell, classes.lightGreenCells)} />
          <div className={clsx(commonClasses.cell, classes.mediumGreenCells)} />
        </div>
      </div>

      <ScrollSyncPanel className={commonClasses.scrollableContent}>
        <VerticalDivider className={commonClasses.horseNumberDivider} />
        <VerticalDivider className={commonClasses.surfaceDivider} />

        {renderRowsContent()}
      </ScrollSyncPanel>
    </div>
  );
};

export default TableFooter;
